/**
 * Created by vtbelo on 04.04.2021
 */

const UnitsShopCart = cc.Node.extend({
    ctor: function () {
        this._super();

        this.setAnchorPoint(0.5, 0.5);

        const styles = cleverapps.styles.UnitsShopCart;

        this.setContentSize2(styles);

        this.icon = new cc.Node();
        this.icon.setAnchorPoint(0.5, 0.5);
        this.icon.setContentSize2(styles);
        this.icon.setCascadeOpacityEnabled(true);
        this.icon.setAlignment(this.width / 2, this.height / 2);
        this.addChild(this.icon);

        const bottomIcon = this.bottomIcon = new cc.Sprite(bundles.tile_shop.frames.cart_bottom_png);
        bottomIcon.setAlignment(styles.bottomIcon);
        this.icon.addChild(bottomIcon);
        const topIcon = this.topIcon = new cc.Sprite(bundles.tile_shop.frames.cart_top_png);
        topIcon.setAlignment(styles.topIcon);
        topIcon.setLocalZOrder(2);
        this.icon.addChild(topIcon);

        this.amountBlock = new cc.Sprite(bundles.tile_shop.frames.cart_amount_bg);
        this.amountBlock.setAlignment(styles.amountBlock);
        this.amountText = cleverapps.UI.generateImageText("", cleverapps.styles.FONTS.UNITSSHOP_CART_AMOUNT);
        this.amountText.setAlignment(styles.amountBlock.amountText);
        this.amountBlock.addChild(this.amountText);
        this.addChild(this.amountBlock);

        this.firstItem = this.target = new cc.Node();
        this.firstItem.setAlignment(styles.item.firstItem.oneItem);
        this.firstItem.setLocalZOrder(1);
        this.icon.addChild(this.firstItem);

        this.secondItem = new cc.Node();
        this.secondItem.setAlignment(styles.item.secondItem);
        this.icon.addChild(this.secondItem);

        this.amount = UnitsShopTab.getCartAmount();
        this.updateCartAmount();

        this.createUnitViews();

        this.setTransient(false);

        cleverapps.aims.registerTarget("cart", this, {
            noDefault: true,
            toggle: (visible, silent) => {
                const parent = this.parent;
                if (parent instanceof UnitsShopCartRibbon) {
                    parent.toggle(visible, silent);
                }
            }
        });
    },

    setTransient: function (transient) {
        this.transient = transient;

        const styles = cleverapps.styles.UnitsShopCart;
        this.setAlignment(transient ? styles.transient : styles);

        this.topIcon.setSpriteFrame(transient ? bundles.tile_shop.frames.simple_cart_top_png : bundles.tile_shop.frames.cart_top_png);
        this.bottomIcon.setSpriteFrame(transient ? bundles.tile_shop.frames.simple_cart_bottom_png : bundles.tile_shop.frames.cart_bottom_png);
    },

    createUnitViews: function () {
        if (!UnitsShop.cartRewards) {
            return;
        }

        UnitsShop.cartRewards.forEach(function (reward) {
            this.addUnitView(reward.getIcon());
        }, this);
    },

    addUnitView: function (unitView) {
        const styles = cleverapps.styles.UnitsShopCart.item;

        if (this.firstItem.children.length) {
            this.secondItem.removeAllChildren();
            this.firstItem.children[0].replaceParent(this.secondItem);
            this.firstItem.removeAllChildren();
            this.firstItem.setAlignment(styles.firstItem.twoItems);
        }

        unitView.setScale(styles.scale);
        cleverapps.UI.fitToBox(unitView, {
            width: styles.width
        });
        unitView.replaceParent(this.firstItem);
    },

    incAmount: function (unitView) {
        this.amount++;
        this.updateCartAmount();

        this.addUnitView(unitView);
    },

    updateCartAmount: function () {
        if (this.amountBlock) {
            this.amountText.setString(this.amount);
            this.amountText.fitTo(cleverapps.styles.UnitsShopCart.amountBlock.amountText.maxWidth);
        }
    },

    createPath: function () {
        const path = new cleverapps.Particles(bundles.particle.jsons.particles_collect_json, bundles.particle.frames.particle_texture);
        path.setScale(1.5);
        path.setLocalZOrder(-1);
        path.setAlignment(this.width / 2, this.height / 2);
        this.addChild(path);
        return path;
    },

    processItems: function (callback) {
        if (!UnitsShop.cartRewards || !UnitsShop.cartRewards.length) {
            callback();
            this.removeFromParent();
            return;
        }

        this.amountBlock.removeFromParent();
        this.amountBlock = undefined;
        const path = this.createPath();

        this.runAction(new cc.Sequence(
            new cc.MoveBy(0.5, {
                x: cleverapps.styles.UnitsShopCart.moveDelta.x / Map2dScroller.currentScroller.getScrollZoom(),
                y: cleverapps.styles.UnitsShopCart.moveDelta.y / Map2dScroller.currentScroller.getScrollZoom()
            }),
            new cc.CallFunc(() => {
                this.setLocalZOrder(-1);
                this.replaceParentSamePlace(Map2d.currentMap.getMapView().animations, {
                    keepScale: true
                });
                UnitsShopTab.processCartUnits(this);
                path.stop();
            }),
            new cc.DelayTime(0.15),
            new cc.CallFunc(() => {
                this.firstItem.setVisible(false);
                this.secondItem.setVisible(false);
            })
        ));

        this.icon.runAction(new cc.Sequence(
            new cc.ScaleTo(0.5, 1.5),
            new cc.DelayTime(0.7),
            new cc.FadeOut(0.3)
        ));

        cleverapps.timeouts.setTimeout(() => {
            this.removeFromParent();
            callback();
        }, 1500);
    },

    showUp: function () {
        this.stopAllActions();
        this.amountBlock.stopAllActions();

        this.amountBlock.setScale(0);
        this.setScale(1.1, 0.9);

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.25),
            new cc.ScaleTo(0.2, 1, 1)
        ));

        this.amountBlock.runAction(new cc.Sequence(
            new cc.DelayTime(0.45),
            new cc.ScaleTo(0.1, 1.1),
            new cc.ScaleTo(0.1, 1)
        ));
    },

    showAnimation: function (silent) {
        this.stopAllActions();
        this.amountBlock.stopAllActions();

        if (silent) {
            this.setScale(1);
            this.amountBlock.setScale(1);
            return;
        }

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.25),
            new cc.ScaleTo(0.2, 1, 1)
        ));

        this.amountBlock.runAction(new cc.Sequence(
            new cc.DelayTime(0.45),
            new cc.ScaleTo(0.1, 1.1),
            new cc.ScaleTo(0.1, 1)
        ));
    },

    hideAnimation: function (silent) {
        this.stopAllActions();

        this.amountBlock.stopAllActions();
        this.amountBlock.setScale(1);

        if (silent) {
            this.amountBlock.setScale(0);
            this.setScale(0.9, 1.1);
            return;
        }

        this.runAction(new cc.Sequence(
            new cc.ScaleTo(0.25, 0.9, 1.1)
        ));

        this.amountBlock.runAction(new cc.Sequence(
            new cc.DelayTime(0.45),
            new cc.ScaleTo(0, 0)
        ));
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    UNITSSHOP_CART_AMOUNT: {
        name: "default",
        size: 40
    }
});

cleverapps.styles.UnitsShopCart = {
    width: 189,
    height: 139,

    x: { align: "right", dx: -70 },
    y: { align: "bottom", dy: 30 },

    transient: {
        x: { align: "right", dx: -20 },
        y: { align: "bottom", dy: 30 }
    },

    bottomIcon: {
        x: { align: "center" },
        y: { align: "center" }
    },

    topIcon: {
        x: { align: "center" },
        y: { align: "center" }
    },

    amountBlock: {
        x: { align: "right", dx: -10 },
        y: { align: "bottom", dy: 4 },

        amountText: {
            x: { align: "center", dx: 1 },
            y: { align: "center", dy: 2 },
            maxWidth: 40
        }
    },

    item: {
        scale: 0.8,
        width: 130,
        firstItem: {
            oneItem: {
                x: { align: "center", dx: -15 },
                y: { align: "bottom", dy: 85 }
            },
            twoItems: {
                x: { align: "center", dx: -30 },
                y: { align: "bottom", dy: 85 }
            }
        },

        secondItem: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 100 }
        }
    },

    moveDelta: {
        x: 500,
        y: 400
    }
};
